module.exports = __webpack_public_path__ + "assets/img/rune.cc8f659d.jpg";